class DetailsDropdown extends HTMLElement{
  constructor(){
      super();
      this.mobile = this.dataset.device == "mobile";
  }

  connectedCallback(){
      this.setup();
      // Add a click event listener to the <details> element
      // fix for publish event in dropdown mobile which is make shrink function in dropdown mobiel not working
      if (!this.mobile) {
        subscribe(PUB_SUB_EVENTS.facetsUpdate, () => {
          this.setup();
        });
      }
  }
  // setup(){
  //     // Store the <details> element
  //     this.el = this.querySelector("details");
  //     // Store the <summary> element
  //     this.summary = this.el.querySelector('summary');
  //     // Store the <div class="content"> element
  //     this.content = this.el.querySelector('ul');
  //     // Store the <div class="expandable"> element
  //     this.expandable = this.el.querySelector(".expandable");
  //     // Store the animation object (so we can cancel it if needed)
  //     this.animation = null;
  //     // Store if the element is closing
  //     this.isClosing = false;
  //     // Store if the element is expanding
  //     this.isExpanding = false;
  //     // Detect user clicks on the summary element
  //     // this.summary.addEventListener('click', (e) => this.onClick(e));
  //     this.bindEvents();
  // }

  setup() {
    this.el = this.querySelector("details");
    this.summary = this.el.querySelector("summary");
    this.iconCaret = this.summary.querySelector(".icon-caret-wrapper svg");
    this.content = this.el.querySelector("ul");
    this.expandable = this.el.querySelector(".expandable");
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
  
    // Imposta lo stato iniziale dell'icona
    if (this.iconCaret) {
      if (this.el.open) {
        this.iconCaret.classList.add('icon-caret-up');
      } else {
        this.iconCaret.classList.add('icon-caret-down');
      }
    }
  
    this.bindEvents();
  }
  
  
  static get observedAttributes() {
    return ['data-action'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if(name == "data-action"){
      if (oldValue != "open") return
      if( newValue == "close" || newValue == "close-fade"){
        this.shrink();
      }

    }
  }

  bindEvents(){
    if (this._boundOnClick) {
      this.summary.removeEventListener('click', this._boundOnClick);
    }
    this._boundOnClick = (e) => this.onClick(e);
    this.summary.addEventListener('click', this._boundOnClick);
  }

  // onClick(e) {
  //     // Stop default behaviour from the browser
  //     e.preventDefault();
  //     this.closeOtherMenu();
  //     // Add an overflow on the <details> to avoid content overflowing
  //     this.el.style.overflow = 'hidden';
  //     // Check if the element is being closed or is already closed
  //     if (this.isClosing || !this.el.open) {
  //         this.open();
  //     // Check if the element is being openned or is already open
  //     } else if (this.isExpanding || this.el.open) {
  //         this.shrink();
  //     }
  // }

  onClick(e) {
    e.preventDefault();
  
    if (!this.iconCaret) return;
  
    const isOpen = this.el.open;
  
    // Aggiorna lo stato dell'icona PRIMA di cambiare lo stato del dropdown
    if (isOpen) {
        this.iconCaret.classList.remove('icon-caret-up');
        this.iconCaret.classList.add('icon-caret-down');
    } else {
        this.iconCaret.classList.remove('icon-caret-down');
        this.iconCaret.classList.add('icon-caret-up');
    }
  
    // Cambia lo stato del dropdown
    this.el.style.overflow = 'hidden';
    if (isOpen) {
      this.shrink();
    } else {
      this.open();
    }
  }
  

  // shrink() {
  //     // Set the element as "being closed"
  //     this.isClosing = true;
      
  //     // Store the current height of the element
  //     const startHeight = `${this.el.offsetHeight}px`;
  //     // Calculate the height of the summary
  //     const endHeight = `${this.summary.offsetHeight}px`;

  //     const animationTime = this.el.offsetHeight - this.summary.offsetHeight;
      
      
  //     // If there is already an animation running
  //     if (this.animation) {
  //         // Cancel the current animation
  //         this.animation.cancel();
  //     }
  //     // check if the element exists
  //     if (this.expandable) {
  //         this.expandable.classList.remove("expanded");
  //     }
      
  //     // Start a WAAPI animation
  //     this.animation = this.el.animate({
  //         // Set the keyframes from the startHeight to endHeight
  //         height: [startHeight, endHeight]
  //     }, {
  //         duration: animationTime,
  //         easing: 'ease-out'
  //     });
     
  //     // When the animation is complete, call onAnimationFinish()
  //     this.animation.onfinish = () => this.onAnimationFinish(false);
  //     // If the animation is cancelled, isClosing variable is set to false
  //     this.animation.oncancel = () => this.isClosing = false;
  //     if(this.dataset.action == "open") this.dataset.action = "close";
  //     this.fade(this.content, false, 100)
  // }

  shrink() {
    if (!this.iconCaret) return;

    this.isClosing = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;
  
    if (this.animation) {
      this.animation.cancel();
    }
    if (this.expandable) {
      this.expandable.classList.remove("expanded");
    }
  
    this.animation = this.el.animate({ height: [startHeight, endHeight] }, { duration: 300, easing: 'ease-out' });
    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  
    this.iconCaret.classList.remove('icon-caret-up');
    this.iconCaret.classList.add('icon-caret-down');
  }
  

  // open() {
  //     // Apply a fixed height on the element
  //     this.el.style.height = `${this.el.offsetHeight}px`;
  //     // Force the [open] attribute on the details element
  //     this.el.open = true;
  //     // Wait for the next frame to call the expand function
  //     window.requestAnimationFrame(() => this.expand());
  //     this.dataset.action = "open";
  // }

  open() {
    if (!this.iconCaret) return;

    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
  
    window.requestAnimationFrame(() => this.expand());
    this.dataset.action = "open";
  
    this.iconCaret.classList.remove('icon-caret-down');
    this.iconCaret.classList.add('icon-caret-up');
  }
  
  expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.el.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      const animationTime = (this.summary.offsetHeight + this.content.offsetHeight) - this.el.offsetHeight;
      
      // If there is already an animation running
      if (this.animation) {
          // Cancel the current animation
          this.animation.cancel();
      }

      if (this.expandable) {
        this.expandable.classList.remove("expanded");
      }
      
      // Start a WAAPI animation
      this.animation = this.el.animate({
          // Set the keyframes from the startHeight to endHeight
          height: [startHeight, endHeight]
      }, {
          // duration: animationTime,
          duration: 300, //introdotto per evitare che il dropdown si apra troppo velocemente
          easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
      if (this.content) this.content.style.opacity = '1';
  }

  fade(element, show, duration) {
      if (!element) return;
      element.style.transition = `opacity ${duration}ms`;
      element.style.opacity = show ? '1' : '0';
  }

  onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.el.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.el.style.height = this.el.style.overflow = '';
      
  }
  closeOtherMenu(){
    document.querySelectorAll("details-dropdown").forEach((el)=>{
      //set attribute true to other elements but not this
      if(!el.isEqualNode(this)){
        el.dataset.action = "close-fade";
      }
    })
  }
}

customElements.define('details-dropdown', DetailsDropdown);